module.exports = function getResource(label, vars = []) {
    let resources = {
        completeStoreList: 'Complete Store List',
        happeningAtSephora: 'Happening at Sephora',
        findASephora: 'Find a Sephora',
        storeLocator: 'Store Locator',
        storeLocations: 'Store Locations'
    };
    return resources[label];
};
